import { render } from "./EditProductFiltersModal.vue?vue&type=template&id=2dbd6c2a&scoped=true"
import script from "./EditProductFiltersModal.vue?vue&type=script&lang=js"
export * from "./EditProductFiltersModal.vue?vue&type=script&lang=js"

import "./EditProductFiltersModal.vue?vue&type=style&index=0&id=2dbd6c2a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbd6c2a"]])

export default __exports__